// extracted by mini-css-extract-plugin
export default {"tc_base":"tc_base","tc_up":"tc_up","tc_base_tabs":"tc_base_tabs","tc_down":"tc_down","img":"img","tc_base_button":"tc_base_button","tc_current_page":"tc_current_page"};